import {createStore, applyMiddleware} from "redux";
import thunk from "redux-thunk";
// xxx only import this in dev env?
import { composeWithDevTools } from 'redux-devtools-extension';

import { rootReducer } from "./reducers.js";


import { updateUrl } from './router.js'

import {
    selectQueryObject
} from './selectors.js'

import * as types from './actionTypes.js'

/*
 * When we make changes to the state that should modify the url
 * make those changes happen here.
 */
const urlModifier = store => next => action => {
    let result = next(action)
    switch (action.type) {
        case types.SORT_CHANGE:
        case types.MODAL_CLOSE:
        case types.FILTER_REPLACE:
        case types.ALL_FILTERS_DEACTIVATE:
        case types.FILTER_GROUP_DEACTIVATE:
        case types.KEYWORD_TEXT_SEARCH:
        case types.KEYWORD_MATCH_COMPLETE:
            var state = store.getState()
            var queryObj = selectQueryObject(state)
            updateUrl(queryObj)
            break;
        default:
            break;
    }
    return result
}

var stateShape = {
    "ui" : {
        "activeModal": null,
        "openNestedLists" : [],
        "keywordText" : ""
    },
    "data": {
        "filters" : [],
        "sorts" : [],
        "activeFilters" : {},
        "activeSort" : null,
        "ignoredParams" : []
    },
    "config": {}
}

var _store = null

export function getStore () {
  return _store
}


export default function configureStore (preloadedState) {
  if (_store) {
    return _store
  }

  const middlewares = [thunk, urlModifier];

  const composedEnhancer = composeWithDevTools(applyMiddleware(...middlewares))

  // console.log(" [ INFO ] Store init : ", preloadedState);

  stateShape.config = preloadedState.config
  stateShape.data = {
    ...stateShape.data,
    ...preloadedState.data
  }

  stateShape.ui = {
    ...stateShape.ui, 
    ...preloadedState.ui
  }

  _store = createStore(
    rootReducer,
    stateShape,
    composedEnhancer
  );

  return _store;
}
